import * as React from "react";

const MARKETPLACE_DEMO_URL = process.env.REACT_APP_MARKETPLACE_DEMO_URL;

export default function MarketplaceDemoScreen() {
    return (
        <iframe
            src={MARKETPLACE_DEMO_URL}
            title="Demo Tienda"
            style={{border: 'none', display: 'block', width: '100vw', height: '100vh'}}
        />
    );
}
